import { Observable } from '@shared/rx';

export interface INotificationBoxItemBase {
  id?: string;
  type?: NotificationType; // <- type of item (info - blue, success - green, warning - yellow, error - red)
  title?: string;
  closeNotification?: Function; //  <- function for closing notification
  onHover?: Function;
  onClick?: Function;
  unitedId?: string;
  isSingleNotificationMsg?: boolean; // <- flag for use one notification message
  isNeedToRemoveOnPageLeave?: boolean;
  ttl?: number;
  showAfter$?: Observable<any>;
}

export interface INotificationBoxItem extends INotificationBoxItemBase {
  id: string;
  type: NotificationType; // <- type of item (info - blue, success - green, warning - yellow, error - red)
  content: NotificationContent;
}

export interface INotificationToaster {
  type: NotificationType;
  title: string;
  message: string;
}

export type NotificationContent =
  // eslint-disable-next-line
  (
    | INotificationHTML
    | INotificationButton
    | INotificationLink
    | INotificationProgress
  )[];

/**
 * TEXT CONTENT
 * Text value passed as HTML and may no contain interactive elements (button, a, input, etc)
 */
export interface INotificationHTML extends INotificationContent {
  htmlString: string; // <- HTML that would be sanitize and insert in span via innerHTML
}

export interface INotificationButton extends INotificationInteractiveContent {
  callBack: Function; // <- function that will be called on button click and get notification id as a parameter
  linkView?: boolean; // <- if set as true, then button view will be the same as the link
}

/**
 * LINK CONTENT
 */
export interface INotificationLink extends INotificationInteractiveContent {
  link: string | string[]; // <- url or router array string to redirect on click
  closeAfterRedirect?: boolean; // <- if set as true, then after redirect the notification would removed
  isExternalLink?: boolean; // <- if set as true, then redirect via href, in other way used Angular Router
  isBlankRedirect?: boolean; // <- if set as true and isExternalLink is true,
  // then open link in new tab, in other way in the current
}

/**
 * PROGRESS CONTENT
 */
export interface INotificationProgress extends INotificationInteractiveContent {
  progress$?: Observable<unknown>;
}

/**
 * Button and link values have additional common fields
 */
export interface INotificationInteractiveContent extends INotificationContent {
  title: string; // <- text inside <button>/<a> tag
  additionalClass?: string | string[]; // <- classes that would be passed to <button>/<a> tag
}

/**
 * All of the content items have common fields
 */
export interface INotificationContent {
  type: NotificationContentType; // <- type of item (html, button, link)
  wrapItem?: boolean; // <- responsible for breaking the line
}

export enum NotificationContentType {
  HTML = 'html',
  BUTTON = 'button',
  LINK = 'link',
  PROGRESS = 'progress',
}

export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  COMMON = 'common',
}
